import { render } from "./DoctorRegister.vue?vue&type=template&id=1c6190a1&scoped=true"
import script from "./DoctorRegister.vue?vue&type=script&lang=js"
export * from "./DoctorRegister.vue?vue&type=script&lang=js"

import "./DoctorRegister.vue?vue&type=style&index=0&id=1c6190a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6190a1"]])

export default __exports__